<app-header></app-header>
<!-- <div *ngIf="failedMessage$ | async as msg" class="failed-banner">
  {{ msg }}</div> -->
 <!--  <button (click)="dismiss()">✕</button> -->

<router-outlet></router-outlet>
<app-footer></app-footer>
